// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".CXTneJgdc-9HDVXmgxRJp {\n  background-color: #00000045;\n  top: 0;\n  left: 0;\n  z-index: 400; }\n\n._3fSjzxjVf3QsHpt42TKdUo {\n  background-color: white;\n  box-shadow: 0 0 1rem gray;\n  border-radius: 0.25rem;\n  min-width: 25vw;\n  min-height: 12rem; }\n\n._3fSjzxjVf3QsHpt42TKdUo > div {\n  min-height: 12rem; }\n\n._3fSjzxjVf3QsHpt42TKdUo > form {\n  min-height: 12rem; }\n", ""]);
// Exports
exports.locals = {
	"overlay": "CXTneJgdc-9HDVXmgxRJp",
	"modalContainer": "_3fSjzxjVf3QsHpt42TKdUo"
};
module.exports = exports;
